import styled from "styled-components";

export const LocationDetailsContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
	height: 100vh;
`;

export const Title = styled.div`
	margin-top: 16px;
	padding: 20px;
	font-size: 36px;
	font-weight: bold;
	text-align: center;
`;

export const Description = styled.div`
	margin-top: 16px;
	padding: 20px;
	font-size: 18px;
	font-weight: bold;
	text-align: center;
`;

export const ImageContainer = styled.div`
	margin-top: 16px;
	width: 100%;
	height: 30vh;
	object-fit: contain;
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
`;

export const PlayerWrapper = styled.div`
	margin-top: 16px;
	width: 100%;
	height: 30vh;
	object-fit: contain;
`;

export const ButtonContainer = styled.div`
	margin-top: 16px;
	margin-bottom: 16px;
	display: flex;
	flex-direction: column;
	align-items: center;
	flex-grow: 1; /* Allow this container to grow and take up the remaining space */
	justify-content: space-evenly;
`;
